import {
  AUTH_URL,
  EXTERNAL_API_URL,
  GEO_VISION_API_URL,
  INFERENCE_API_URL,
  MISSION_PLANNER_API_URL,
  ODM_API_URL,
  PDF_API_URL,
  WIKI_API_URL
} from "../constant";

import ApiProvider, { ProviderInterface } from "./ApiProvider";

export const ODMProvider = ApiProvider(ODM_API_URL);
export const MapProvider = ApiProvider(GEO_VISION_API_URL);
export const MissionPlannerProvider = ApiProvider(MISSION_PLANNER_API_URL);
export const ExternalProvider = ApiProvider(EXTERNAL_API_URL);
export const PDFProvider = ApiProvider(PDF_API_URL);
export const InferenceProvider = ApiProvider(INFERENCE_API_URL);
export const AuthProvider = ApiProvider(AUTH_URL);
export const WikiProvider = ApiProvider(WIKI_API_URL);

const providers: ProviderInterface[] = [
  ODMProvider,
  MapProvider,
  MissionPlannerProvider,
  ExternalProvider,
  PDFProvider,
  InferenceProvider,
  AuthProvider,
  WikiProvider
];

export const updateProvidersToken = (token: string): void => {
  providers.forEach((provider) => provider.setInterceptors(token));
};
